export default function(editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { collectionOptions } = opt;
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        .input[type=data-group-text] {
            display:none;
        }
        .width100{
          width: 100%;
        }
  `;
  document.head.appendChild(style);
  traitManager.addType('data-group-field-src', {
    createInput({ trait }) {
      const traitOpts = trait.get('options') || [];
      const options = traitOpts;
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="URL">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getSrcFrom"
                           style="all: revert;"/>
                    Get Image From ${trait.get('collectionTitle')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="select-field-div" style="display: none">
               <select class="selectField form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      // const radioButton = el.querySelector("input[name=getTextFrom]");
      const checkbox = el.querySelector('input[type=checkbox][name="getSrcFrom"]');
      const selectFieldDiv = el.querySelector('#select-field-div');
      const selectField = el.querySelector('.selectField');
      checkbox.addEventListener('click', async ev => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map(opt => `<option value="${opt.id}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-group-field-uuid', {
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-group-field', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="URL">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getTextContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="field-text-select-div" style="display: none">
               <select class="field-text-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      // const radioButton = el.querySelector("input[name=getTextFrom]");
      const checkbox = el.querySelector('input[type=checkbox][name="getTextContent"]');
      const selectFieldDiv = el.querySelector('#field-text-select-div');
      const selectField = el.querySelector('.field-text-select');
      checkbox.addEventListener('click', async ev => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-progress-now', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="PROGRESS-NOW">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getProgressNowContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="progress-now-select-div" style="display: none">
               <select class="progress-now-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getProgressNowContent"]');
      const selectFieldDiv = el.querySelector('#progress-now-select-div');
      const selectField = el.querySelector('.progress-now-select');
      checkbox.addEventListener('click', async ev => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onProgressNowTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onProgressNowTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-progress-min', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="PROGRESS-MIN">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getProgressMinContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="progress-min-select-div" style="display: none">
               <select class="progress-min-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getProgressMinContent"]');
      const selectFieldDiv = el.querySelector('#progress-min-select-div');
      const selectField = el.querySelector('.progress-min-select');
      checkbox.addEventListener('click', async ev => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onProgressMinTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onProgressMinTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-progress-max', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      el.innerHTML = `    
    <div id="PROGRESS-MAX">
    <div class="form-group">
    <label>
                    <input type="checkbox" name="getProgressMaxContent"
                           style="all: revert;"/>
                    ${trait.get('title')}
                </label>
      
    </div>
    <div class="form-group">
         <div id="progress-max-select-div" style="display: none">
               <select class="progress-max-select form-control form-control-sm options-light">
                   
               </select>
         </div>
     </div>
    </div>
    `;
      const checkbox = el.querySelector('input[type=checkbox][name="getProgressMaxContent"]');
      const selectFieldDiv = el.querySelector('#progress-max-select-div');
      const selectField = el.querySelector('.progress-max-select');
      checkbox.addEventListener('click', async ev => {
        if (ev.target.checked) {
          selectField.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
          optionHtml += `${options
            .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
            .join('')}`;
          selectField.innerHTML = optionHtml;
          selectFieldDiv.style.display = 'block';
        } else {
          selectFieldDiv.style.display = 'none';
        }
      });
      return el;
    },
    onEvent({ elInput, component }) {
      onProgressMaxTraitsChange(elInput, component, this.model);
    },
    onUpdate({ elInput, component }) {
      onProgressMaxTraitsUpdate(elInput, component, this.model);
    },
  });
  traitManager.addType('data-map-trait', {
    createInput({ trait }) {
      const options = trait.get('options') || [];
      const el = document.createElement('div');
      el.classList.add('custom-field');
      let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="">None</option>`;
      optionHtml += `${options
        .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join('')}`;
      el.innerHTML = `    
      <div id="DATA-MAP">
        <div class="form-group">
          <div id="data-map-select-div">
            <select id="${trait.get('title')}" class="form-control form-control-sm options-light">
                ${optionHtml}
            </select>
          </div>
        </div>
      </div>
    `;
      return el;
    },
    onEvent({ elInput, component, trait }) {
      onDataMapTraitsChange(elInput, component, this.model, trait.get('title'));
    },
    onUpdate({ elInput, component, trait }) {
      onDataMapTraitsUpdate(elInput, component, this.model, trait.get('title'));
    },
  });
}

const onTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.field-text-select');
  const checkbox = elInput.querySelector('input[name="getTextContent"]:checked');
  let selectFieldValue = select.value;
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  console.log('selectFieldValue::', selectFieldValue, '--', checkbox);
  let attr = component.getAttributes();
  const id = attr.id;
  if (component.get('type') !== 'link') {
    // attr = {}; //* Commented to Fix component attributes reset issue.
    attr.id = id;
  }
  const selectedField = traits.attributes.options.find(field => {
    if (field && field.id) {
      if ((field.type && field.type === 'utility') || field.id.includes('"')) {
        return field.id === selectFieldValue.split('"').join("'");
      } else return field.id === selectFieldValue;
    }
  });
  const fieldType = selectedField ? selectedField.type : '';
  if (fieldType) {
    attr['data-field-type'] = fieldType;
  } else delete attr['data-field-type'];
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  }
  component.setAttributes(attr);
  if (traitsFieldAttr !== 'data-img-src') {
    component.set('content', '');
    component.set('content', select.options[select.selectedIndex].text);
  }
  console.log('component :>>', component);
};
const onTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.field-text-select');
    let checkbox = elInput.querySelector('input[name="getTextContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#field-text-select-div');
    select.innerHTML = '';
    let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
    optionHtml += `${traitOptions
      .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
      .join('')}`;
    select.innerHTML = optionHtml;
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onProgressNowTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.progress-now-select');
  const checkbox = elInput.querySelector('input[name="getProgressNowContent"]:checked');
  let selectFieldValue = select.value;
  const defaultNowValue = '25';
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  } else {
    attr[traitsFieldAttr] = defaultNowValue;
  }
  component.setAttributes(attr);
};
const onProgressNowTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.progress-now-select');
    let checkbox = elInput.querySelector('input[name="getProgressNowContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#progress-now-select-div');
    select.innerHTML = '';
    let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
    optionHtml += `${traitOptions
      .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
      .join('')}`;
    select.innerHTML = optionHtml;
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onProgressMinTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.progress-min-select');
  const checkbox = elInput.querySelector('input[name="getProgressMinContent"]:checked');
  let selectFieldValue = select.value;
  const defaultMinValue = '0';
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }

  let attr = component.getAttributes();
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  } else {
    attr[traitsFieldAttr] = defaultMinValue;
  }
  component.setAttributes(attr);
};
const onProgressMinTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.progress-min-select');
    let checkbox = elInput.querySelector('input[name="getProgressMinContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#progress-min-select-div');
    select.innerHTML = '';
    let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
    optionHtml += `${traitOptions
      .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
      .join('')}`;
    select.innerHTML = optionHtml;
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onProgressMaxTraitsChange = (elInput, component, traits) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector('.progress-max-select');
  const checkbox = elInput.querySelector('input[name="getProgressMaxContent"]:checked');
  let selectFieldValue = select.value;
  const defaultMaxValue = '100';
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }

  let attr = component.getAttributes();
  if (checkbox && selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  } else {
    attr[traitsFieldAttr] = defaultMaxValue;
  }
  component.setAttributes(attr);
};
const onProgressMaxTraitsUpdate = (elInput, component, traits) => {
  const traitOptions = traits.get('options') || [];
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector('.progress-max-select');
    let checkbox = elInput.querySelector('input[name="getProgressMaxContent"]');
    checkbox.checked = true;
    const selectFieldDiv = elInput.querySelector('#progress-max-select-div');
    select.innerHTML = '';
    let optionHtml = `<option value="" selected>- Select One -</option>
                              <option value="" >None</option>`;
    optionHtml += `${traitOptions
      .map(opt => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
      .join('')}`;
    select.innerHTML = optionHtml;
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
    selectFieldDiv.style.display = 'block';
  } else {
  }
};

const onDataMapTraitsChange = (elInput, component, traits, title) => {
  const traitsFieldAttr = traits.get('name');
  const select = elInput.querySelector(`#${title}`);
  let selectFieldValue = select.value;
  if (selectFieldValue.includes("'")) {
    selectFieldValue = selectFieldValue.split("'").join('"');
  }
  let attr = component.getAttributes();
  if (selectFieldValue) {
    attr[traitsFieldAttr] = selectFieldValue;
  }
  component.setAttributes(attr);
};

const onDataMapTraitsUpdate = (elInput, component, traits, title) => {
  const attr = component.getAttributes();
  let selectedValue = attr[traits.get('name')];
  if (selectedValue) {
    const select = elInput.querySelector(`#${title}`);
    if (selectedValue.includes('"')) {
      selectedValue = selectedValue.split('"').join("'");
    }
    select.value = selectedValue;
  }
};
